<template>
    <div id="tour-02" class="tour">
        <p class="title">SEARCH BAR</p>
        <p class="description">Looking for something? Type your questions here and we search for you in all your content.</p>
        <div class="box-button">
            <button class="btn-next" @click="nextTour03">CONTINUE &nbsp;<i class="fas fa-chevron-right"></i></button>
            <svg id="icon" xmlns="http://www.w3.org/2000/svg" width="51.059" height="51.059" viewBox="0 0 51.059 51.059">
                <g id="Group_351" data-name="Group 351" transform="translate(-163.838 -159.703)">
                    <g id="Group_351-2" data-name="Group 351" transform="translate(163.838 159.703)">
                    <path id="Path_313" data-name="Path 313" d="M189.368,210.762a25.53,25.53,0,1,1,25.529-25.53A25.559,25.559,0,0,1,189.368,210.762Zm0-48.517a22.988,22.988,0,1,0,22.987,22.987A23.014,23.014,0,0,0,189.368,162.245Z" transform="translate(-163.838 -159.703)" fill="#fff"/>
                    </g>
                    <g id="Group_352" data-name="Group 352" transform="translate(181.127 172.525)">
                    <path id="Path_314" data-name="Path 314" d="M196.266,196.812a10.865,10.865,0,0,1,.55-3.844,6.012,6.012,0,0,1,1.786-2.444,11.881,11.881,0,0,0,1.876-1.894,3.092,3.092,0,0,0,.642-1.893q0-2.519-2.168-2.519a2.011,2.011,0,0,0-1.618.734,3.122,3.122,0,0,0-.651,1.985h-5.638a6.724,6.724,0,0,1,2.1-5.2,8.375,8.375,0,0,1,5.8-1.86,8.7,8.7,0,0,1,5.763,1.718,6.03,6.03,0,0,1,2.044,4.887,5.7,5.7,0,0,1-.55,2.519,8.523,8.523,0,0,1-1.768,2.319l-1.918,1.784a4.522,4.522,0,0,0-1.134,1.61,6.379,6.379,0,0,0-.35,2.094Zm-.684,5.072a2.59,2.59,0,0,1,.892-2.027,3.525,3.525,0,0,1,4.454,0,2.747,2.747,0,0,1,0,4.054,3.525,3.525,0,0,1-4.454,0A2.588,2.588,0,0,1,195.582,201.883Z" transform="translate(-191.045 -179.881)" fill="#fff"/>
                    </g>
                </g>
            </svg>
        </div>
        <span class="btn-close" @click="close">CLOSE</span>

        <svg id="arrow-tour-02" xmlns="http://www.w3.org/2000/svg" width="29.145" height="25.133" viewBox="0 0 29.145 25.133">
            <path id="Path_315" data-name="Path 315" d="M370.893,404.27,356.32,429.4h29.145Z" transform="translate(-356.32 -404.27)" opacity="0.7"/>
        </svg>
    </div>
</template>

<script>
import Tour from '@/services/TourPlugin.js'
export default {
    name : 'tour-02',
    methods: {
        nextTour03() {
            Tour.Tour03();
        }
    }
}
</script>

<style lang="scss" scoped>
    #tour-02 {
        position: absolute;
        background-color: rgba(0,0,0,.7);
        width: 471px;
        padding: 30px;
        top: calc(100% + 25px);
        left: 20px;
        color: #FFF;

        #arrow-tour-02 {
            position: absolute;
            top: -25px;
            left: 0;
        }

        .title {
            font-size: 26px;
            font-weight: bold;
        }

        .description {
            font-size: 14px;
        }

        .box-button {
            position: relative;
            display: flex;
            align-items: center;
            margin-top: 40px;

            .btn-next {
                background-color:var(--primary-color);
                color: #FFF;
                border: none;
                padding: 8px 15px;
                font-size: 14px;
            }

            #icon {
                position: absolute;
                right: 0px;
            }
        }
        
        .btn-close {
            cursor: pointer;
            position: absolute;
            top: 3px;
            right: 5px;
            font-size: 12px;
            color: #B9B9B9;
        }
    }
</style>


